export function version(full = '0.0.0', codeName = '') {
  if (typeof full !== 'string') full = '0.0.0'

  let [major, minor, dot] = full.split(/\./g)
  major = Number(major) || 0
  minor = Number(minor) || 0
  dot = Number(dot) || 0

  const v = {
    full,
    major,
    minor,
    dot,
  }

  if (codeName) v.codeName = codeName

  return v
}

export const dotpath = (...parts) => {
  let str = ''

  for (let i = 0; i < parts.length; ++i) {
    if (i > 0) str += '.'

    str += parts[i]
  }

  return str
}

// Given an input return a unique string based on a timestamp
export const uniqueString = (strName) => {
  const ts = Date.now()
  return `${strName} ${ts}`
}
